import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
import AcceptCreditWrapper from "@components/layouts/acceptcreditWrapper";

export default function CarInjuryJusticeHome(): ReactElement {
    return (
        <AcceptCreditWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#2F5F63" />
                </div>
                <FormSection iconsFillColor="#2F5F63" />
            </div>
        </AcceptCreditWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
